const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const convertShortUUIDToReadable = (shortUUID: string) => {
  const n = Number(`0x${shortUUID}`);
  return n.toString(36);
};

const convertReadableToShortUUID = (readable: string) => {
  const n = parseInt(readable, 36);
  return n.toString(16).padStart(8, '0');
};

export const extractShortUUID = (uuid?: string | null) => {
  if (!uuid) {
    return undefined;
  }
  if (uuid.match(UUID_REGEX)) {
    return uuid;
  }
  return convertReadableToShortUUID(uuid);
};

export const readableUUID = (uuid?: string) => {
  if (!uuid || !uuid.match(UUID_REGEX)) {
    return undefined;
  }

  const short = uuid.replace(/-/g, '').slice(0, 8);
  return convertShortUUIDToReadable(short);
};
